const core = require('./core');
// const axios = require('axios');
// const utilities = require('../utilities');

// const log = true;

// //HOTFIX FOR CERT ERR
// var https = require('https');
// //HOTFIX FOR CERT ERR
// const agent = new https.Agent({
//   rejectUnauthorized: false,
// });

const thirdParty = {
  //A service fee charged by the ride share company facilitating the ride
  //TODO: This needs to be dynamic based upon the region
  rideShareServiceFee: 2.65,

  //A base fare used to calculate ride share return ride cost
  //TODO: This needs to be dynamic based upon the region
  rideShareBaseFare: 1,

  //A cost per mile for a ride share return ride
  //TODO: This needs to be dynamic based upon the region
  rideShareCostPerMile: 0.9,

  //A cost per minute for a ride share return ride
  //TODO: This needs to be dynamic based upon the region
  rideShareCostPerMinute: 0.17,

  //A ride share API fee for making the request (per call)
  rideShareAPIRequestFee: 1,

  //The insurance per mile rate
  //insuranceRatePerMile: 0.26,

  /**
   * Multiply per mile insurance rate by number of miles
   *
   * @param  {int} miles - The number of miles distance (ex: 6.6 mi)
   * @param  {int} perMileRate - The per mile insurance rate
   * @return  {int} - Insurance cost in dollars
   */
  getPerMileInsuranceCost: function (miles, perMileRate) {
    return perMileRate * miles;
  },

  /**
   * @param  {int} miles - The number of miles distance (ex: 6.6 mi)
   * @param  {int} avgMph - The average speed of travel (ex: 40 mph)
   * @param  {int} tolls - The dollars to add to the cost for expected tolls on route
   * @return  {int} - Return ride cost in dollars
   */
  getEstimatedReturnRideCost: function (miles, avgMph, tolls, rideshareRate) {
    let driveTimeAsSeconds = core.getDriveTimeAsSeconds(miles, avgMph);
    let serviceFee = rideshareRate && rideshareRate.service_fee ? rideshareRate.service_fee : this.rideShareServiceFee;
    let baseFare = rideshareRate && rideshareRate.initial_cost ? rideshareRate.initial_cost : this.rideShareBaseFare;
    let costPerMile = rideshareRate && rideshareRate.per_mile_rate ? rideshareRate.per_mile_rate : this.rideShareCostPerMile;
    let costPerMinute = rideshareRate && rideshareRate.per_minute_rate ? rideshareRate.per_minute_rate : this.rideShareCostPerMinute;

    return (
      serviceFee +
      baseFare +
      miles * costPerMile +
      (driveTimeAsSeconds / 60) * costPerMinute +
      this.rideShareAPIRequestFee +
      tolls
    );
  },

  //NOTE: this function is not currently used. But, it works, so I figured I'd leave it here in case anyone needs to use it in the future
  /**
   * Fetch the active insurance rate for the customer_id entered. This is found through the associated raterulegroup.
   * If none is found, use the default insurance rate returned from the database
   *
   * @param  {int} customerId - The customer id associated with the insurance rate
   * @return  {int} - Insurance cost in dollars
   */
  // getPerMileInsuranceRate: async function (customerId) {
  //   log && console.log('GETTING INSURANCE RATES customerId: ', customerId);
  //   try {
  //     return await axios({
  //       url: server,
  //       method: 'post',
  //       data: {
  //         query: getInsuranceRate,
  //         variables: {
  //           customerId: customerId
  //         },
  //       },
  //       headers: {
  //         'content-type': 'application/json',
  //         'x-hasura-admin-secret': secret,
  //       },
  //       //HOTFIX FOR CERT ERR
  //       httpsAgent: agent,
  //     }).then(res => {
  //       const response = utilities.getPropValue(res, 'data.data');
  //       log && console.log('RESPONSE: ', response);
  //       const customerInsuranceRate =
  //         response.insurancerates && Array.isArray(response.insurancerates) && response.insurancerates.length
  //           ? response.insurancerates[0]
  //           : null;
  //       log && console.log('RATES: ', customerInsuranceRate);
  //       //If there is a defined, non-expired insurance rate assigned to the customer's active raterulegroup (their "contract")
  //       if (customerInsuranceRate) {
  //         const rate = customerInsuranceRate.rate;
  //         log && console.log('customerInsuranceRate', customerInsuranceRate, 'rate', rate);
  //         return rate;
  //       }
  //       //If no rate is found, we return 0 because the rate is unknown
  //       console.error('Failed to find appropriate insurance rate.');
  //       return 0;
  //     });
  //   } catch (err) {
  //     //If there is an error finding the rate, we return 0 the rate could not be found
  //     console.error('Failed to get insurance rate from GQL server.');
  //     return 0;
  //   }
  // },
};

module.exports = thirdParty;

// const getInsuranceRate = `
//     query getPerMileInsuranceRates($customerId: bigint!) {
//         insurancerates(where: {
//               type: {_ilike: "per mile"}
//               effective_date:{_lte: "now()"}
//               expiration_date:{_gte: "now()"}
//               raterulegroups: {
//                 customer_id: {_eq: $customerId},
//                 begin_date: {_lte: "now()"},
//                 end_date: {_gte: "now()"}
//               }
//           }){
//             id
//             rate
//         }
//     }
// `;
